import {CreateTeamInviteDto, fetchTeamInviteCreate} from '@blesk-frontend/api';
import {Button, FieldGroup, Input, Modal, ModalProps} from '@blesk-frontend/ui';
import {useQueryClient} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import {useForm} from 'react-hook-form';
import {toast} from 'sonner';

import {sendEvent} from '@/libs/analytics';

export const CreateTeamInviteModal = (props: ModalProps) => {
  const queryClient = useQueryClient();
  const {
    register,
    handleSubmit,
    formState: {isSubmitting, isValid},
  } = useForm<CreateTeamInviteDto>();

  const onSubmit = handleSubmit(async (data) => {
    try {
      await fetchTeamInviteCreate(data);
      queryClient.invalidateQueries({queryKey: ['team-members']});
      queryClient.invalidateQueries({queryKey: ['team-invites']});
      toast.success('Приглашение отправлено');
      sendEvent('teams/invite-send');
      props.onClose?.();
    } catch (error) {
      if (error instanceof AxiosError) {
        switch (error.response?.data.message) {
          case 'Invite already sent to this email':
            toast.error('Приглашение уже отправлено на эту почту');
            break;
          case 'User already in this team':
            toast.error('Пользователь уже в этой команде');
            break;
          default:
            console.error(error);
            toast.error('При отправке приглашения произошла ошибка');
        }
      } else {
        console.error(error);
        toast.error('При отправке приглашения произошла ошибка');
      }
    }
  });

  return (
    <Modal {...props}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        <h1 className="text-title-h1">Пригласить коллегу</h1>

        <p className="text-paragraph-md text-text-primary">
          Укажите электронную почту пользователя, которого вы&nbsp;хотите пригласить для совместной
          работы над&nbsp;инструкциями. На указанный адрес будет отправлено приглашение.
        </p>

        <div className="flex flex-col gap-1.5">
          <FieldGroup label="Электронная почта" labelFor="email">
            <Input
              {...register('email', {
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: 'Entered value does not match email format',
                },
                required: 'Обязательное поле',
                minLength: {value: 5, message: 'Минимум 5 символов'},
              })}
              id="email"
              placeholder="Укажите электронную почту"
            />
          </FieldGroup>
        </div>

        <Button className="w-fit" type="submit" disabled={!isValid} loading={isSubmitting}>
          Выслать приглашение
        </Button>
      </form>
    </Modal>
  );
};
